import React, { useContext, useEffect, useState } from 'react'
import {
  CalendarIconContainer,
  CalendarOptionButton,
  CalendarOptionContainer,
  CalendarPictureAndNameContainer,
} from './MentorCalendarIntegrationStyles'
import { MentorProfileContext } from 'src/mentor/context/MentorProfileContext'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import { Menu, MenuItem } from '@mui/material'
import { toast } from 'react-toastify'
import { getMPDataWithoutParams } from 'src/mentor/services'
import googleCalendarIcon from 'src/assets/google_calendar_icon.png'

export const GoogleCalendarIntegrationComponent = ({ tempCalendarConnected }) => {
  const { mentorProfileData, updateProfileData } = useContext(MentorProfileContext)
  const [anchorEl, setAnchorEl] = useState(null)

  const CLIENT_ID = import.meta.env.VITE_GOOGLE_OAUTH_CLIENT_ID_CALENDAR
  // const DISCOVERY_DOCS = ['https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest'];
  const REDIRECT_URI = window.location.href
  const SCOPES = ['https://www.googleapis.com/auth/calendar.events']

  const isCalendarConnected =
    (Array.isArray(mentorProfileData?.connectedCalendars) &&
      mentorProfileData?.connectedCalendars?.includes('google')) ||
    tempCalendarConnected

  function generateGoogleOAuthUrl() {
    const authorizationEndpoint = 'https://accounts.google.com/o/oauth2/v2/auth'

    // Construct the URL with query parameters
    const url = new URL(authorizationEndpoint)
    url.searchParams.append('client_id', CLIENT_ID)
    url.searchParams.append('redirect_uri', REDIRECT_URI)
    url.searchParams.append('response_type', 'code')
    url.searchParams.append('scope', SCOPES.join(' '))
    url.searchParams.append('prompt', 'consent')
    url.searchParams.append('access_type', 'offline')
    // url.searchParams.append('state', "STATE VALUE");

    // window.open(url.toString()); // opens in new tab
    window.location.href = url.toString()
    return url.toString()
  }

  function connectCalendar() {
    if (isCalendarConnected) return
    else {
      generateGoogleOAuthUrl()
    }
  }

  async function disconnectCalendar() {
    const response = await getMPDataWithoutParams(`/api/secure/teacher/remove-calendar?type=google`)
    if (response?.status === 200) {
      toast.success('Calendar Disconnected')
      updateProfileData()
    } else {
      toast.error('Could not disconnect Calendar')
    }
  }

  return (
    <CalendarOptionContainer>
      <CalendarPictureAndNameContainer>
        <CalendarIconContainer>
          <img style={{ width: '50%', height: '50%' }} alt="icon" src={googleCalendarIcon} />
        </CalendarIconContainer>
        <div>Google Calendar</div>
      </CalendarPictureAndNameContainer>
      <CalendarOptionButton onClick={connectCalendar}>
        {isCalendarConnected ? 'Connected' : 'Connect'}
      </CalendarOptionButton>
      {isCalendarConnected && (
        <div>
          <MoreVertIcon
            style={{ cursor: 'pointer' }}
            onClick={(event) => {
              setAnchorEl(event.currentTarget)
            }}
          />
        </div>
      )}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem
          onClick={() => {
            disconnectCalendar()
            setAnchorEl(null)
          }}
        >
          Disconnect
        </MenuItem>
      </Menu>
    </CalendarOptionContainer>
  )
}
